import { Box, Card, CardContent, makeStyles, MenuItem, Select, Typography } from '@material-ui/core'
import React from 'react'
import Loader from './Loader'
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
    margin: '20px 10px 0px 10px',
    padding: '13px 10px 0px 12px',

    // width: '100%',
  },
  padding: {
    height: '96%',
    // paddingBottom: '30px',
  },
  title1: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '19px',
    letter: '0.5px',
    margin: 5,
    color: '#313131',
  },
  root2: {
    margin: '20px 0px 0px 0px',
  },
  noMarginTop: {
    margin: '0px',
    paddingBottom: '13px',
  },
}))
export default function CardWithChart({ children, className, heading, select, noMargin, noMarginTop, className2 }) {
  const classes = useStyles()
  return (
    <Card
      variant="outlined"
      className={
        noMargin
          ? `${classes.root} ${classes.root2}`
          : noMarginTop
          ? `${classes.root} ${classes.noMarginTop}`
          : className
          ? `${classes.root} ${classes.padding}`
          : className2
          ? `${classes.root} ${className2}`
          : classes.root
      }
    >
      {select ? (
        <Box display="flex" justifyContent="space-between">
          {' '}
          <Typography className={classes.title3}>{heading}</Typography>
          <div className={classes.drop} style={{ height: '15px' }}>
            <Select labelId="label" id="select" value="2020" style={{ fontSize: '12px' }}>
              <MenuItem value="2020" style={{ fontSize: '12px' }}>
                2020
              </MenuItem>
              <MenuItem value="2021" style={{ fontSize: '12px' }}>
                2021
              </MenuItem>
            </Select>
          </div>
        </Box>
      ) : (
        <Typography className={classes.title1}>{heading}</Typography>
      )}
      <div style={{ padding: '10px' }}>{children}</div>
    </Card>
  )
}
